import Vue from 'vue'
import prefetchService from './../prefetch'
import accountService from './../account'
import store from './../../store'
// When the request succeeds
const success = (token) => {
  store.dispatch('auth/login', token)
  prefetchService()
  // accountService.find()
}

// When the request fails
const failed = () => {
}

export default ({ email, password }) => {
  const user = { username: email, password }
  return Vue.$http.post('/auth/obtain_token/', user)
      .then((response) => {
        // :TODO: not use default value
        const token = (response.data && response.data.token) || 'emptyToken'
        success(token)
      }).catch((error) => {
        failed(error)
        throw error
      })
}



// WEBPACK FOOTER //
// ./src/services/auth/login.js